import { c as _c } from "react/compiler-runtime";
import { Field, FieldError, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, selectVariant, Spinner } from '@repo/ui/components';
import { cn, VariantProps } from '@repo/ui/lib/utils';
import { ComponentProps } from 'react';
import { ReadOnlyTooltip, useReadOnly } from '../../components/readonly.tsx';
import { useFieldContext } from '../../lib/form-context.ts';
export const FormCustomsResponsiblePartySelect = t0 => {
  const $ = _c(33);
  const {
    "data-testid": dataTestId,
    isPending: t1,
    organisationName,
    placeholder: t2,
    variant: t3
  } = t0;
  const isPending = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "" : t2;
  const variant = t3 === undefined ? "default" : t3;
  const field = useFieldContext();
  const t4 = organisationName ?? "Organisation";
  let t5;
  if ($[0] !== t4) {
    t5 = {
      label: t4,
      value: "organisation"
    };
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      label: "Customer",
      value: "customer"
    };
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== t5) {
    t7 = [t5, t6];
    $[3] = t5;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const options = t7;
  const isReadOnly = useReadOnly();
  if (isReadOnly) {
    const t8 = options.find(option => option.value === field.state.value)?.label ?? "-";
    let t9;
    if ($[5] !== t8) {
      t9 = <ReadOnlyTooltip>{t8}</ReadOnlyTooltip>;
      $[5] = t8;
      $[6] = t9;
    } else {
      t9 = $[6];
    }
    return t9;
  }
  let t8;
  if ($[7] !== field) {
    t8 = val => val && field.handleChange(val);
    $[7] = field;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = field.state.value;
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cn("flex w-full justify-between gap-2 p-0 text-base data-[size=default]:h-6");
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const t11 = dataTestId ?? "form-customs-responsible-party-select-trigger";
  let t12;
  if ($[10] !== placeholder) {
    t12 = <SelectValue placeholder={placeholder} data-sentry-element="SelectValue" data-sentry-source-file="form-customs-responsible-party-select.tsx" />;
    $[10] = placeholder;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== isPending) {
    t13 = isPending && <Spinner className="text-muted-foreground ml-auto size-4" />;
    $[12] = isPending;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t11 || $[15] !== t12 || $[16] !== t13 || $[17] !== variant) {
    t14 = <SelectTrigger className={t10} data-testid={t11} hideChevron={true} variant={variant} data-sentry-element="SelectTrigger" data-sentry-source-file="form-customs-responsible-party-select.tsx">{t12}{t13}</SelectTrigger>;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
    $[17] = variant;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== options) {
    t15 = <SelectContent data-sentry-element="SelectContent" data-sentry-source-file="form-customs-responsible-party-select.tsx">{options.map(_temp)}</SelectContent>;
    $[19] = options;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== field.state.value || $[22] !== isPending || $[23] !== options || $[24] !== t14 || $[25] !== t15 || $[26] !== t8) {
    t16 = <div className="relative"><Select disabled={isPending} items={options} onValueChange={t8} value={t9} data-sentry-element="Select" data-sentry-source-file="form-customs-responsible-party-select.tsx">{t14}{t15}</Select></div>;
    $[21] = field.state.value;
    $[22] = isPending;
    $[23] = options;
    $[24] = t14;
    $[25] = t15;
    $[26] = t8;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== field.state.meta.errors) {
    t17 = <FieldError errors={field.state.meta.errors} data-sentry-element="FieldError" data-sentry-source-file="form-customs-responsible-party-select.tsx" />;
    $[28] = field.state.meta.errors;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t16 || $[31] !== t17) {
    t18 = <Field className="gap-1" data-sentry-element="Field" data-sentry-component="FormCustomsResponsiblePartySelect" data-sentry-source-file="form-customs-responsible-party-select.tsx">{t16}{t17}</Field>;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  return t18;
};
function _temp(option_0) {
  return <SelectItem data-testid={`form-customs-responsible-party-select-option-${option_0.value}`} key={option_0.value} value={option_0.value}>{option_0.label}</SelectItem>;
}